import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconSearch = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 11.3333C7 8.9401 8.9401 7 11.3333 7C13.7266 7 15.6667 8.9401 15.6667 11.3333C15.6667 13.7266 13.7266 15.6667 11.3333 15.6667C8.9401 15.6667 7 13.7266 7 11.3333ZM11.3333 5C7.83553 5 5 7.83553 5 11.3333C5 14.8311 7.83553 17.6667 11.3333 17.6667C14.8311 17.6667 17.6667 14.8311 17.6667 11.3333C17.6667 7.83553 14.8311 5 11.3333 5ZM19.6072 18.1928L16.7072 15.2928L15.293 16.7071L18.193 19.6071L19.6072 18.1928Z"
        />
      </svg>
    );
  }
);
